module.exports = __webpack_public_path__ + "img/img_activation_email_3.05e2ed4e.png";